import React, { useMemo } from 'react'
import PropTypes from "prop-types";
import { validateDTDCDeliveryDetails } from '../../helper';
import RecipientSelector from '../../RecipientSelector';

// import { DEFAULT_PACKAGE_BOXES } from '../../constants';
// import _ from 'lodash';

const DeliveryDetailsForm = ({ deliveryData, setDeliveryData, userPatientAddresses, mapUserPatient, onContinue }) => {
    const selectedAddress = useMemo(
        () => userPatientAddresses?.find((a) => String(a.id) === String(deliveryData.billingAddressId)),
        [userPatientAddresses, deliveryData.billingAddressId]
    );
    // const [packageBox, setPacketBox] = useState(Object.keys(DEFAULT_PACKAGE_BOXES)[0]);

    const handleBillingAddressChange = (addressId) => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                billingAddressId: addressId,
            }
        })
    }

    // const setDimenstions = (dimension, value) => {
    //     if (dimension !== 'length' && dimension !== 'breadth' && dimension !== 'height') {
    //         return;
    //     }

    //     setDeliveryData((prevState) => {
    //         return {
    //             ...prevState,
    //             packageDetails: {
    //                 ...prevState.packageDetails,
    //                 [dimension]: value,
    //             }
    //         }
    //     })
    // }

    // const setWeight = (weight) => {
    //     setDeliveryData((prevState) => {
    //         return {
    //             ...prevState,
    //             packageDetails: {
    //                 ...prevState.packageDetails,
    //                 weight: weight,
    //             }
    //         }
    //     })
    // }

    const setUnits = (units) => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                packageDetails: {
                    ...prevState.packageDetails,
                    units: units,
                }
            }
        })
    }

    const setSubTotal = (price) => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                packageDetails: {
                    ...prevState.packageDetails,
                    subTotal: price,
                }
            }
        })
    }

    const setCODAmount = (codAmount) => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                packageDetails: {
                    ...prevState.packageDetails,
                    codAmount
                }
            }
        })
    }

    const handleConfirmDeliveryDetails = () => {
        if (!validateDTDCDeliveryDetails(deliveryData)) {
            return;
        }
        onContinue();
    }

    const handleSetIsCOD = (isCod) => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                packageDetails: {
                    ...prevState.packageDetails,
                    codAmount: isCod ? prevState.packageDetails.subTotal : 0,
                    isCod
                }
            }
        })
    }

    const handleToggleContainsLiquid = () => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                packageDetails: {
                    ...prevState.packageDetails,
                    containsLiquid: !prevState?.packageDetails?.containsLiquid,
                }
            }
        })
    }

    // useEffect(() => {
    //     setDeliveryData((prevState) => {
    //         return {
    //             ...prevState,
    //             packageDetails: {
    //                 ...prevState.packageDetails,
    //                 length: DEFAULT_PACKAGE_BOXES[packageBox].length,
    //                 breadth: DEFAULT_PACKAGE_BOXES[packageBox].breadth,
    //                 height: DEFAULT_PACKAGE_BOXES[packageBox].height,
    //                 weight: DEFAULT_PACKAGE_BOXES[packageBox].weight,
    //             }
    //         }
    //     });
    // }, [])

    return (
        <div className='flex flex-col gap-[0.9rem]' >
            <div className='flex flex-col' >
                <label>Select Billing Address</label>
                <select className='w-full' value={deliveryData.billingAddressId} onChange={(e) => handleBillingAddressChange(e.target.value)} >
                    {
                        userPatientAddresses && userPatientAddresses.map((userPatientAddress) => {
                            return (
                                <option key={userPatientAddress.id} value={userPatientAddress.id} >
                                    {`${userPatientAddress.name} | ${userPatientAddress.phone} | ${userPatientAddress.line}, ${userPatientAddress.district}, ${userPatientAddress.state}, ${userPatientAddress.pincode}`}
                                </option>
                            )
                        })
                    }
                </select>
            </div>
            {/* <div className='flex flex-col' >
                <label>Package</label>
                <select className='w-full' value={packageBox} onChange={(e) => setPacketBox(e.target.value)}  >
                    {
                        Object.keys(DEFAULT_PACKAGE_BOXES).map((key) => {
                            return (
                                <option key={DEFAULT_PACKAGE_BOXES[key].name} value={key} >
                                    <span>{`${_.capitalize(DEFAULT_PACKAGE_BOXES[key].name.split("-").join(" "))} | ${DEFAULT_PACKAGE_BOXES[key].length}cm X ${DEFAULT_PACKAGE_BOXES[key].breadth}cm X ${DEFAULT_PACKAGE_BOXES[key].height}cm`}</span>
                                </option>
                            )
                        })
                    }
                </select>
            </div> */}
            {/* <div>
                <label>Package Dimensions ( in cm )</label>
                <div className='flex items-center justify-between' >
                    <div className='flex flex-col' >
                        <span>Length</span>
                        <input type='number' min={0.5} value={deliveryData.packageDetails.length} onChange={(e) => setDimenstions('length', e.target.value)} />
                    </div>
                    <span>X</span>
                    <div className='flex flex-col' >
                        <span>Breadth</span>
                        <input type='number' min={0.5} value={deliveryData.packageDetails.breadth} onChange={(e) => setDimenstions('breadth', e.target.value)} />
                    </div>
                    <span>X</span>
                    <div className='flex flex-col' >
                        <span>Height</span>
                        <input type='number' min={0.5} value={deliveryData.packageDetails.height} onChange={(e) => setDimenstions('height', e.target.value)} />
                    </div>
                </div>
            </div> */}
            {/* <div className='flex gap-[0.9rem]' >
                <div className='flex flex-col flex-1' >
                    <label>Dead Weight(in kg)</label>
                    <input type='number' min={0} value={deliveryData.packageDetails.weight} onChange={(e) => setWeight(e.target.value)} />
                </div>
                <div className='flex flex-col flex-1' >
                    <label className='!text-gray-400' >Volumetric Weight(in kg)</label>
                    <input type='number' disabled className='!border-gray-400' value={(deliveryData.packageDetails.length * deliveryData.packageDetails.breadth * deliveryData.packageDetails.height) / 5000 || 0} />
                </div>
            </div> */}
            <div className='flex gap-[0.9rem]' >
                <div className='flex flex-col flex-1' >
                    <label>Units</label>
                    <input type='number' min={1} value={deliveryData.packageDetails.units} onChange={(e) => setUnits(e.target.value)} />
                </div>
                <div className='flex flex-col flex-1' >
                    <label>Total Amount</label>
                    <input type='number' min={0} value={deliveryData.packageDetails.subTotal} onChange={(e) => setSubTotal(e.target.value)} />
                </div>
            </div>
            <div className='flex flex-col  gap-[0.9rem]' >
                <div className='flex gap-[0.5rem] items-center' >
                    <input id="contains-liquid-input" type={'checkbox'} className='m-0 p-0' checked={deliveryData?.packageDetails?.containsLiquid} onChange={handleToggleContainsLiquid} />
                    <label className='m-0 p-0' htmlFor="contains-liquid-input" >Contains Liquid</label>
                </div>
            </div>
            <div className='flex flex-col  gap-[0.9rem]' >
                <div className='flex gap-[0.5rem] items-center' >
                    <input id="is-cod-input" type={'checkbox'} className='m-0 p-0' checked={deliveryData?.packageDetails?.isCod} onChange={() => handleSetIsCOD(!deliveryData?.packageDetails?.isCod)} />
                    <label className='m-0 p-0' htmlFor="is-cod-input" >Is COD</label>
                </div>
                {
                    deliveryData?.packageDetails?.isCod && <div className='flex flex-col flex-1' >
                        <label>COD Amount</label>
                        <input type='number' min={0} value={deliveryData.packageDetails.codAmount} onChange={(e) => setCODAmount(parseInt(e.target.value))} />
                    </div>
                }
            </div>
            <RecipientSelector
                userName={mapUserPatient?.User?.name || ''}
                userPhone={mapUserPatient?.User?.contact_no || ''}
                patientName={mapUserPatient?.Patient?.name || ''}
                patientPhone={mapUserPatient?.Patient?.contact_no || ''}
                addressName={selectedAddress?.name || ''}
                addressPhone={selectedAddress?.phone || ''}
                recipientName={deliveryData.recipientName || ''}
                recipientPhone={deliveryData.recipientPhone || ''}
                onNameChange={(val) => setDeliveryData((prev) => ({ ...prev, recipientName: val }))}
                onPhoneChange={(val) => setDeliveryData((prev) => ({ ...prev, recipientPhone: val }))}
            />

            <div className='flex justify-end' >
                <button onClick={handleConfirmDeliveryDetails} className='bg-[#28A48B] p-[1rem] rounded-[0.5rem] text-white-50 font-semibold' >Select Courier</button>
            </div>
        </div>
    )
}

DeliveryDetailsForm.propTypes = {
    deliveryData: PropTypes.object.isRequired,
    setDeliveryData: PropTypes.func.isRequired,
    userPatientAddresses: PropTypes.array.isRequired,
    mapUserPatient: PropTypes.object,
    onContinue: PropTypes.func.isRequired,
    orderData: PropTypes.object.isRequired,
};

export default DeliveryDetailsForm